﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const form_controls_1 = require("@its-suite/form-controls");
const PasswordField_1 = require("./PasswordField");
const customPasswordValidationName = 'customPasswordValidation';
class NewPasswordFields extends React.Component {
    constructor(props) {
        super(props);
        this.renderPasswordField = (name, label, value, validators, autoComplete) => {
            let content = this.getPasswordField(name, label, value, validators, autoComplete);
            let result;
            if (this.props.renderOuterDivs) {
                result = (React.createElement("div", { className: this.props.outerDivsClassName }, content));
            }
            else {
                result = content;
            }
            return result;
        };
        this.validatePassword = (username, password) => {
            const texts = this.props.texts;
            const passwordMinLength = 8;
            const alphaNumericRegex = '^[a-zA-Z0-9]*$';
            let isValid = true;
            let passwordErrorResource = '';
            if (password.length < passwordMinLength) {
                passwordErrorResource = form_controls_1.StringHelpers.format(texts.lengthError, passwordMinLength);
                isValid = false;
            }
            else if (password.toUpperCase() === password) {
                passwordErrorResource = texts.shouldContainLowerCaseError;
                isValid = false;
            }
            else if (password.toLowerCase() === password) {
                passwordErrorResource = texts.shouldContainUpperCaseError;
                isValid = false;
            }
            else if (password.match(alphaNumericRegex)) {
                passwordErrorResource = texts.shouldContainNonAlphanumericError;
                isValid = false;
            }
            else if (username && password.includes(username)) {
                passwordErrorResource = texts.shouldNotContainUserNameError;
                isValid = false;
            }
            if (!isValid) {
                this.setState({ errorMessage: passwordErrorResource });
            }
            return isValid;
        };
        this.state = {
            errorMessage: ''
        };
        this.confirmationPasswordValidator = new form_controls_1.Validator({
            validatorType: form_controls_1.ValidatorTypes.ConfirmationPassword,
            message: this.props.texts.confirmationError
        });
        this.passwordValidator = new form_controls_1.Validator({
            validatorType: form_controls_1.ValidatorTypes.Custom,
            validatorName: customPasswordValidationName,
            message: ''
        });
        this.requiredValidator = new form_controls_1.Validator({ validatorType: form_controls_1.ValidatorTypes.Required, message: this.props.texts.requiredFieldError });
    }
    componentDidMount() {
        form_controls_1.ValidatorForm.addValidationRule('isPasswordMatch', confirmationPassword => confirmationPassword === this.props.passwordValue);
        form_controls_1.ValidatorForm.addValidationRule(customPasswordValidationName, updatedPassword => {
            return this.validatePassword(this.props.userName, updatedPassword);
        });
    }
    render() {
        this.passwordValidator.message = this.state.errorMessage;
        return (React.createElement(React.Fragment, null,
            this.renderPasswordField('password', this.props.texts.password, this.props.passwordValue, [this.requiredValidator, this.passwordValidator], 'new-password'),
            this.renderPasswordField('confirmationPassword', this.props.texts.confirmPassword, this.props.confirmationPasswordValue, [this.confirmationPasswordValidator], 'off')));
    }
    getPasswordField(name, label, value, validators, autoComplete) {
        return (React.createElement(PasswordField_1.PasswordField, { name: name, label: label, value: value, prefixId: this.props.prefixId, onChange: this.props.onChange, onFocus: this.props.onFocus, validators: validators, disabled: this.props.disabled, autoComplete: autoComplete, className: this.props.className }));
    }
}
exports.NewPasswordFields = NewPasswordFields;
NewPasswordFields.defaultProps = {
    className: '',
    renderOuterDivs: false,
    outerDivsClassName: ''
};
//# sourceMappingURL=NewPasswordFields.js.map